module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w-full mt-4 px-2 cursor-pointer rounded",
    class: [
      !_vm.submissionOpened ? ['clickable', 'collapsed-card'] : null,
      _vm.submission.is_hidden ? 'hidden-record' : '' ],
    attrs: {
      "id": ("submission-card-" + (_vm.submission.id))
    },
    on: {
      "mouseover": function($event) {
        _vm.isHoverCard = true
      },
      "mouseleave": function($event) {
        _vm.isHoverCard = false
      },
      "click": function($event) {
        return _vm.handleClickSubmission()
      }
    }
  }, [_c('CardHeader', {
    attrs: {
      "showCollapseButton": _vm.submissionOpened,
      "submission": _vm.submission,
      "isInSummary": _vm.isInSummary,
      "isInPlag": _vm.isPlagPanel,
      "plagPanelName": _vm.plagStudentName,
      "loadingSubmission": _vm.loadingSubmission,
      "showVerticalDotMenu": _vm.showVerticalDotMenu,
      "isCardHover": _vm.isHoverCard
    },
    on: {
      "minimize": _vm.closeSubmission,
      "showHistoryVersion": _vm.showHistoryVersion,
      "showDeleteSubmissionModal": function($event) {
        return _vm.$emit('showDeleteSubmissionModal', _vm.submission)
      },
      "showHideSubmissionModal": function($event) {
        return _vm.$emit('showHideSubmissionModal', _vm.submission)
      },
      "addModelSubmission": _vm.addModelSubmission,
      "showAnonymousDescription": _vm.openAnonymityModal,
      "closeSubmission": _vm.collapseSubmissionCard,
      "openSubmission": function($event) {
        _vm.EventBus.$emit('sidebar-recap', false);
        _vm.handleTabButtons('comments', 'card')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-11",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        !_vm.submissionOpened ? _vm.handleTabButtons('comments', 'card') : ''
      }
    }
  }, [(_vm.submissionOpened) ? _c('div', {
    staticClass: "submission-response mb-3"
  }, [_c('section', {
    staticClass: "text-sm text-justify",
    domProps: {
      "innerHTML": _vm._s(_vm.getSubmissionPromptResponse)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-4 text-left text-xs text-gray-600"
  }, [_vm._v("\n          " + _vm._s(_vm.getPromptWordsLength) + " Words\n        ")])]) : _c('div', [_c('section', {
    staticClass: "ellipsis-text text-left text-sm"
  }, [_vm._v("\n          " + _vm._s(_vm.getTrimmedSubmissionPromptResponse) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex py-5",
    attrs: {
      "id": ("submission-tab-row-" + (_vm.submission.id))
    }
  }, [_c('button', {
    staticClass: "mr-2 px-5 py-2 bg-gray-100 cursor-pointer border border-solid border-gray-200 rounded text-xs font-semibold hover:border-blueGray-500 hover:text-white hover:bg-blueGray-500",
    class: [
      _vm.cardTabButtonClasses('comments'),
      _vm.collapse_comments === false ?
      'bg-blueGray-500 text-white' :
      'text-gray-400' ],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleTabButtons('comments', true)
      }
    }
  }, [_vm._v("\n          Comments (" + _vm._s(_vm.submission.comment_count) + ")\n        ")]), _vm._v(" "), (
    (_vm.hasTeacherPermissionsInCourse &&
      !_vm.submission.teacher_submission) ||
    (!_vm.hasTeacherPermissionsInCourse &&
      _vm.submission.id === _vm.getMyRTUserDetails.submission_id)
  ) ? _c('button', {
    staticClass: "flex items-center rounded px-5 py-2 cursor-pointer text-xs font-semibold hover:bg-blueGray-500 hover:text-white hover:border-blueGray-500 border border-solid border-gray-200",
    class: [
      _vm.cardTabButtonClasses('assessment'),
      _vm.hasEvaluation(_vm.submission) && _vm.collapse_assessment === true ?
      'text-green-500 hover:text-white' :
      _vm.collapse_assessment === false ?
      'text-white' :
      'text-gray-400',
      _vm.collapse_assessment === false ?
      'bg-blueGray-500 text-white border-blueGray-500' :
      ' bg-gray-100' ],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleTabButtons('assessment', 'card')
      }
    }
  }, [_vm._v("\n          Assessment\n          "), (_vm.hasEvaluation(_vm.submission)) ? _c('i', {
    staticClass: "fas fa-check ml-2"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (
    (_vm.tabToShow === 'comments' && _vm.submissionOpened) ||
    _vm.model_submission_show
  ) ? _c('CommentsTab', {
    key: ("comment-" + (_vm.submission.id)),
    attrs: {
      "submission": _vm.submission,
      "showComments": _vm.show_comments,
      "showModelSubmission": _vm.model_submission_show,
      "isInSummary": _vm.isInSummary,
      "isFromNotification": _vm.isFromNotification
    },
    on: {
      "toggleSubmissionComments": _vm.toggleSubmissionComments,
      "getComments": _vm.getComments,
      "closeModelSubmission": _vm.closeModelSubmission
    }
  }) : _vm._e(), _vm._v(" "), (_vm.submissionOpened) ? _c('div', {
    staticClass: "my-6 flex justify-center"
  }, [_c('button', {
    key: "collapse",
    staticClass: "bg-white text-blueGray-500 hover:border-blueGray-700 hover:text-blueGray-700 border border-solid border-blueGray-500 rounded-full px-4 py-1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.collapseSubmissionCard()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-up"
  })])]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.show_anonymous_description_modal) ? _c('AnonymousCharacterDescriptionModal', {
    attrs: {
      "anonymous_identity": _vm.identity_to_show
    },
    on: {
      "close": function($event) {
        _vm.show_anonymous_description_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-24d3880b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/submissionCard/submissionCard.vue
// module id = 1109
// module chunks = 61